export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCB1gcwNniawterznR44UBm3rVceJ-S030",
    authDomain: "youandme-d50b3.firebaseapp.com",
    databaseURL: "https://youandme-d50b3.firebaseio.com",
    projectId: "youandme-d50b3",
    storageBucket: "youandme-d50b3.appspot.com",
    messagingSenderId: "977457252558"

  }
};



// WEBPACK FOOTER //
// ./src/environment/environment.ts